import { Routes } from '@angular/router';
import { AuthGuard } from '@features/uc/guards/auth.guard';

export const routes: Routes = [
  {
    path: '404',
    title: 'Unibox - Not Found',
    loadComponent: () => import('./features/404/404.page').then((p) => p.NotFoundPage)
  },
  {
    path: 'loading/:guid',
    title: 'Unibox - Loading...',
    loadComponent: () => import('./features/loading/loading.page').then((p) => p.LoadingPage)
  },
  {
    path: 'denom/:guid',
    title: 'Unibox - Denom Selection',
    loadComponent: () => import('./features/denom-selection/denom-selection.page').then((p) => p.DenomSelectionPage)
  },
  {
    path: 'channel/:guid',
    title: 'Unibox - Channel Selection',
    loadComponent: () => import('./features/channel-selection/channel-selection.page').then((p) => p.ChannelSelectionPage)
  },
  {
    path: 'checkout/:guid',
    title: 'Unibox - Checkout',
    loadComponent: () => import('./features/checkout/checkout.page').then((p) => p.CheckoutPage)
  },
  {
    path: 'payment/va/:guid',
    title: 'Unibox - VA Payment',
    loadComponent: () => import('./features/payment-actions/va/va-payment-action.page').then((p) => p.VaPaymentActionPage)
  },
  {
    path: 'payment/qr/:guid',
    title: 'Unibox - QR Payment',
    loadComponent: () => import('./features/payment-actions/qr/qr-payment-action.page').then((p) => p.QrPaymentActionPage)
  },
  {
    path: 'payment/guide/:guid',
    title: 'Unibox - Payment Guide',
    loadComponent: () => import('./features/payment-actions/guide/guide-payment-action.page').then((p) => p.GuidePaymentActionPage)
  },
  {
    path: 'payment/form/:guid',
    title: 'Unibox - Payment Redirection',
    loadComponent: () => import('./features/payment-actions/form-redirect/form-redirect-payment-action.page').then((p) => p.FormRedirectPaymentActionPage)
  },
  {
    path: 'payment/otp/:guid',
    title: 'Unibox - Payment OTP',
    loadComponent: () => import('./features/payment-actions/otp/otp-payment-action.component').then((p) => p.OtpPaymentActionComponent)
  },
  {
    path: 'payment/js/:guid',
    title: 'Unibox - Payment Redirection',
    loadComponent: () => import('./features/payment-actions/js/js-payment-action.component').then((p) => p.JSPaymentActionComponent)
  },
  {
    path: 'payment/intent/:guid',
    title: 'Unibox - Payment',
    loadComponent: () => import('./features/payment-actions/intent/intent.component').then((p) => p.IntentComponent)
  },
  {
    path: 'payment/shield/:guid',
    title: 'Unibox - Checkout',
    loadComponent: () => import('./features/payment-actions/shield/shield-payment.component').then((p) => p.ShieldPaymentComponent)
  },
  {
    path: 'payment/redirect/:guid',
    title: 'Unibox - Payment Redirection',
    loadComponent: () => import('./features/payment-actions/redirect-payment/redirect-payment.component').then((p) => p.RedirectPaymentComponent)
  },
  {
    path: 'uc/login/:guid',
    title: 'Unibox - Login',
    loadComponent: () => import('./features/uc/pages/login/uc-login.page').then((p) => p.UcLoginPage)
  },
  {
    path: 'uc/:guid',
    canActivate: [ AuthGuard ],
    title: 'Unibox - UniPin Credits Checkout',
    loadComponent: () => import('./features/uc/pages/pin/uc-pin.page').then((p) => p.UcPinPage)
  },
  {
    path: 'uv/:guid',
    title: 'Unibox - UniPin Voucher Checkout',
    loadComponent: () => import('./features/uv/uv.page').then((p) => p.UvPage)
  },
  {
    path: '**',
    title: 'Unibox - Not Found',
    loadComponent: () => import('./features/404/404.page').then((p) => p.NotFoundPage)
  }
];
